import Vue from 'vue'
// import { findIndex } from 'lodash'
// import moment from 'moment'

const def = {1: 0, 2: 0, 3: 0, 4: 0, 5: 0}

export default {

  get_unread_chats ({commit, state}, callback) {
    new Vue().$hit_post({url: 'hitclick/chat/get_unread',
      data: {user: state.user.md5_id, activeUser: 1},
      callback: function (ret) {
        if (!ret.data[0]) {
          commit('set_unread_chat_messages', [])
          return false
        }

        commit('set_unread_chat_messages', ret.data[1])

        callback()
      }})
  },

  set_chat ({commit, state}, data) {
    new Vue().$hit_post({url: 'hitclick/chat/set',
      data: data,
      callback: function (ret) {
        console.log(ret)
      }})
  },
  set_conflict_mail ({commit, state}, email) {
    new Vue().$hit_post({url: 'hitclick/votes/send_conflict',
      data: email,
      callback: function (ret) {
        for (var i = 0; i < store.votes.length; i++) {
          if (store.votes[i].ID == email.ID && store.votes[i].board == email.board) {
            store.votes[i].delete = ret.data[2]
            return false
          }
        }
      // console.log(ret);
      }})
  },
  set_invitation ({commit, state}, email) {
    new Vue().$hit_post({url: 'hitclick/invitation/set',
      data: email,
      callback: function (ret) {

      // console.log(ret);

      }})
  },

  set_change_target_page ({commit, state}, page) {
    new Vue().$hit_post({url: 'hitclick/targetpage/set',
      data: page,
      callback: function (ret) {
        commit('set_change_target_page', page)
      }})
  },

  get_all_target_pages ({commit, state}, user) {
    new Vue().$hit_post({url: 'hitclick/targetpage/get',
      data: {user: user},
      callback: function (ret) {
        if (ret.data[0]) { commit('set_target_pages', ret.data[1]) }
      }})
  },

  set_change_board ({commit, state}, board) {
    var send = {
      user: state.user.md5_id,
      ID: state.boards[board.index].ID,
      data: board.data
    }

    new Vue().$hit_post({url: 'hitclick/board/update',
      data: send,
      callback: function (ret) {
        commit('set_change_board', board)
      }})
  },

  set_remove_board ({commit, state}, board) {
    var send = {
      user: state.user.md5_id,
      data: {ID: state.boards[board].ID}
    }

    new Vue().$hit_post({url: 'hitclick/board/delete',
      data: send,
      callback: function (ret) {
        commit('set_remove_board', board)
      }})
  },

  set_new_board ({commit, state}, board) {
    var send = {
      user: state.user.md5_id,
      data: board.data
    }

    new Vue().$hit_post({url: 'hitclick/board/insert',
      data: send,
      callback: function (ret) {
        send.data.ID = ret.data[1]
        window.console.log(ret)
        if (typeof board.callback === 'function') { send.callback = board.callback }

        commit('set_new_board', send)
      }})
  },

  get_user_boards ({commit, state}, data) {
    var my_class = this

    if (this.getters.user.boards) { return false }

    commit('get_session_user')

    if (!this.getters.user.md5_id) { return false }

    var send = {
      user: this.getters.user.md5_id
    }

    new Vue().$hit_post({url: 'hitclick/board/get',
      data: send,
      callback: function (ret) {
        if (ret.data[0]) {
          commit('set_boards', ret.data[1])

          for (var i = 0; i < ret.data[1].length; i++) {
            my_class.dispatch('get_board_feedback', ret.data[1][i].ID)
          }

          if (typeof data === 'object' && typeof data.callback === 'function') { data.callback() }
        }
      }})
  },

  get_board_feedback ({commit, state}, board) {
    if (this.getters.user.feedbacks) { return false }

    commit('get_session_user')

    if (!this.getters.user.md5_id) { return false }

    new Vue().$hit_post({url: 'hitclick/feedback/get',
      data: {user: this.getters.user.md5_id, board: board},
      callback: function (ret) {
        if (typeof ret.data !== 'object' || ret.data.length == 0) { return false }

        commit('set_feedback', {data: ret.data, board: board})
      }})
  },

  get_all_votes ({commit, state}, settings) {
    if (this.getters.user.votes) { return false }

    commit('get_session_user')

    if (!this.getters.user.md5_id) { return false }

    var send = {
      user: this.getters.user.md5_id
    }

    var my_class = this
    new Vue().$hit_post({url: 'hitclick/votes/get',
      data: send,
      callback: function (ret) {
        if (ret.data[0]) {
          commit('set_votes', ret.data[1])

          if (typeof settings === 'object' && typeof settings.callback === 'function') { settings.callback() }
        }
      }})
  },

  set_admin_comment: function ({commit, state}, data){

    new Vue().$hit_post({url: 'hitclick/votes/comment',
      data: data,
      callback: function (ret) {

        commit("set_admin_comment", data);


      }})


  }

}
